<template>
  <v-container fluid grid-list-xl class="maxh-1bar" style="overflow-y: auto">
    <v-layout row wrap>
      <v-flex sm12>
        <ClientDetails :client="value" @reload="$emit('reload')" />
      </v-flex>

      <v-flex sm6>
        <ClientHeartbeats :client="value" @reload="$emit('reload')" />
      </v-flex>

      <v-flex sm6>
        <v-layout column>
          <v-flex>
            <ClientComments :client="value" @reload="$emit('reload')" />
          </v-flex>
          <v-flex>
            <ClientTrips :client="value" @reload="$emit('reload')" />
          </v-flex>
          <v-flex>
            <ClientMailboxPortlet :client="value" @reload="$emit('reload')" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ClientComments from './ClientComments.vue'
import ClientDetails from './ClientDetails.vue'
import ClientHeartbeats from './ClientHeartbeats.vue'
import ClientTrips from './ClientTrips.vue'
import ClientMailboxPortlet from './mailbox/ClientMailboxPortlet.vue'

export default {
  tabTitle: 'Geral',
  tabGroup: 'Módulo',
  tabBadgeFn: (client) => {
    if (client.hasReminder) {
      return {
        icon: 'mdi-exclamation-thick',
        color: 'amber darken-2'
      }
    }
  },
  components: {
    ClientDetails,
    ClientHeartbeats,
    ClientComments,
    ClientTrips,
    ClientMailboxPortlet
  },
  props: {
    value: { required: true }
  }
}
</script>

<style></style>
